import { Component, HostListener, Input, OnInit } from '@angular/core';
import { OeAppPersonService } from '../oe-app-person.service';
import { ProgressCircleDto } from '../progress-circle/progress-circle-dto';
import { ProgressType } from '../progress-type';
import { TranslatePipe } from '../translate.pipe';
import { LevelProgressDto } from '../types/LevelProgressDto';

@Component({
  selector: 'lp2-level-goals',
  templateUrl: './level-goals.component.html',
  styleUrls: ['./level-goals.component.scss'],
})
export class LevelGoalsComponent implements OnInit {
  @Input() progressData: LevelProgressDto;

  @Input() isWideStyle = true;

  @Input()
  hasDetailsContent = false;

  @Input()
  indexUrl?: string;

  @Input()
  set gamificationEnabledValue(data: boolean) {
    this.gamificationEnabled = data;
    this.calculateGamificationCircleInputs();
  }

  gamificationEnabled = false;

  circleRadius = 60;
  gameCircleRadius = 70;
  gameCircleTitleFontSize = '2.5rem';
  gameCircleSubtitleFontSize = '1.25rem';
  circleSubtitleColor = '#444444';

  ProgressType = ProgressType;
  liveClassEnabled: boolean;

  @HostListener('window:resize', ['$event'])
  resizeEvent() {
    this.calculateGamificationCircleInputs();
  }

  constructor(public translatePipe: TranslatePipe, private readonly oeAppPersonService: OeAppPersonService) {}

  ngOnInit() {
    if (!this.isWideStyle) {
      this.circleRadius = 53;
    }
    this.calculateGamificationCircleInputs();
    this.liveClassEnabled = this.oeAppPersonService.liveClassEnabled;
  }

  calculateGamificationCircleInputs() {
    if (this.gamificationEnabled) {
      this.gameCircleSubtitleFontSize = this.isWideStyle ? '1.25rem' : '1rem';
      if (document.documentElement.clientWidth > 710) {
        this.gameCircleRadius = this.isWideStyle ? 70 : 58;
        this.gameCircleTitleFontSize = this.isWideStyle ? '2.5rem' : '2rem';
        this.circleSubtitleColor = '#444444';
      } else {
        this.gameCircleRadius = this.isWideStyle ? 55 : 40;
        this.gameCircleTitleFontSize = '2rem';
        this.circleSubtitleColor = '#999999';
      }
    }
  }

  getProgressCircleDto(progressType: ProgressType): ProgressCircleDto {
    if (!this.progressData) {
      return null;
    }
    let progressCircleDto;
    switch (progressType) {
      case ProgressType.LIVECLASSES:
        progressCircleDto = {
          percentage: this.progressData.liveClassProgressPercent,
          currentValue: this.progressData.liveClassTaken,
          maxValue: this.progressData.liveClassRequired,
          titleText: this.translatePipe.transform('progress.liveClasses'),
          measurementUnit: this.translatePipe.transform('progress.classes'),
          continueLink: '/#lp2-live-class-carousel',
          progressType: progressType,
          detailText: 'progress.xOfYLiveClasses',
        };
        break;
      case ProgressType.UNITS:
        progressCircleDto = {
          percentage: this.progressData.unitProgressPercent,
          currentValue: this.progressData.unitTaken,
          maxValue: this.progressData.unitRequired,
          titleText: this.translatePipe.transform('progress.units'),
          measurementUnit: this.translatePipe.transform('progress.units'),
          continueLink: '/#lp2-lesson-carousel',
          unitIndexLink: this.indexUrl,
          progressType: progressType,
          detailText: 'progress.xOfYUnits',
        };
        break;
      case ProgressType.PRACTICES:
        progressCircleDto = {
          percentage: this.progressData.practiceProgressPercent,
          currentValue: this.progressData.practiceTaken,
          maxValue: this.progressData.practiceRequired,
          titleText: this.translatePipe.transform('progress.practiceHours'),
          measurementUnit: this.translatePipe.transform('progress.hours'),
          continueLink: '/#lp2-practice-section',
          progressType: progressType,
          detailText: 'progress.xOfYPractice',
        };
        break;
    }
    return progressCircleDto;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/level-goals/level-goals.component.ts